var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCloseXCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icCloseXCircle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M920.081264,723.140959 C919.807662,722.867357 919.364597,722.867357 919.091685,723.140959 L916.107625,726.124982 L913.165251,723.182643 C912.893718,722.911111 912.454139,722.911111 912.183333,723.182643 C911.911801,723.454176 911.911801,723.893755 912.183333,724.164561 L915.125708,727.106935 L912.163217,730.069426 C911.889615,730.343028 911.889615,730.786057 912.163217,731.059005 C912.436819,731.331954 912.879884,731.331954 913.152796,731.059005 L916.115323,728.096514 L919.057662,731.038853 C919.329194,731.310385 919.768773,731.310385 920.039615,731.038853 C920.311147,730.76732 920.311147,730.327741 920.039615,730.056899 L917.09724,727.114561 L920.0813,724.130537 C920.354866,723.857625 920.354866,723.413907 920.081264,723.140959 Z M916.111111,716 C909.974292,716 905,720.974292 905,727.111111 C905,733.24793 909.974292,738.222222 916.111111,738.222222 C922.247204,738.222222 927.222222,733.247204 927.222222,727.111111 C927.222222,720.975018 922.24793,716 916.111111,716 Z M916.111111,736.833333 C910.741649,736.833333 906.388889,732.480574 906.388889,727.111111 C906.388889,721.741649 910.741649,717.388889 916.111111,717.388889 C921.480574,717.388889 925.833333,721.741649 925.833333,727.111111 C925.833333,732.480574 921.480574,736.833333 916.111111,736.833333 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-Message-hover",
    transform: "translate(-905.000000, -716.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icCloseXCircle",
    fill: "#646464",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseXCircle);
export default __webpack_public_path__ + "static/media/icCloseXCircle.d41d86aca9a188817e6e1a995ecc946b.svg";
export { ForwardRef as ReactComponent };